import { createSelector } from "reselect"
import { AppState } from "~/store/reducer"

export const getGlobalMessages = createSelector(
  (state: AppState) => state.messages,
  (messages) => messages.global
)
